const TOUR_STATES = {
  preTour: 'pre-tour',
  postTour: 'post-tour',
  duringTour: 'during-tour',
  fullCashflowReviewFinished: 'full-cashflow-review-finished',
};

const state = {
  tourState: TOUR_STATES.preTour,
};

const getters = {
  isPreTour: state => state.tourState === TOUR_STATES.preTour,
  isDuringTour: state => state.tourState === TOUR_STATES.duringTour,
  isPostTour: state => state.tourState === TOUR_STATES.postTour,
};

const actions = {
  setDuringTour({ commit }) {
    commit('setDuringTour');
  },
  setPostTour({ commit }) {
    commit('setPostTour');
  },
  setFullCashflowReviewFinished({ commit }) {
    commit('setFullCashflowReviewFinished');
  },
};

const mutations = {
  setDuringTour(state) {
    state.tourState = TOUR_STATES.duringTour; // eslint-disable-line
  },
  setPostTour(state) {
    state.tourState = TOUR_STATES.postTour; // eslint-disable-line
  },
  setFullCashflowReviewFinished(state) {
    state.tourState = TOUR_STATES.fullCashflowReviewFinished; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
